import { ContextMenu, ContextMenuItem } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useBoardMenuContainer } from '../../../hooks/useBoardMenuContainer';
import { RowItem } from '../../../stores/TimetableVersion/PinboardStoreTypes';
import styles from './../TimetableGrid.module.scss';
import { useTimetableStore } from '../TimetableProvider';

type HiddenGridRowProps = {
  row: RowItem;
};

export const HiddenGridRow: FC<HiddenGridRowProps> = observer(({ row }) => {
  const pinboardStore = useTimetableStore();
  const menuContainer = useBoardMenuContainer('timetable-grid');
  const { t } = useTranslation();

  const contextMenu: ContextMenuItem[] = [
    {
      label: t('pinboard.actions.showRows'),
      onClick: (e) => {
        e.stopPropagation();
        pinboardStore.toggleRowsVisibility([row]);
      },
    },
  ];

  return (
    <ContextMenu data={contextMenu} parent={menuContainer}>
      <div className={styles['hidden-row']} title={row.label}>
        <span className={styles['hidden-row-label']}>{row.label}</span>
      </div>
    </ContextMenu>
  );
});
